module.exports = __webpack_public_path__ + "img/Kd.e24658ac.png";